import React from 'react'
import Configurator from '../../configurator'
import { withRouterConnectWrapper } from '../../validator'
import { Redirect } from 'react-router'
import { SET_REDIRECT_URL } from '../../admin/reducers/auth-forms'
import store, { asyncSessionStorage } from '../../admin/store'
import { getUrlParameter } from '../../admin/actions'
import { redirectToRemoteLoginBacklink } from './remote-login-redirect'

class RemoteLogin extends Configurator {
    componentDidMount() {
        store.dispatch({
            type: SET_REDIRECT_URL,
            redirectUrl: `/remote-login`
        })

        if (getUrlParameter('backlink')) {
            this.setBacklinkStorage()
        }

        const authedUser = this.props?.authedUser
        if (!!authedUser?.user) {
            redirectToRemoteLoginBacklink(authedUser.tokens)
        }
    }

    /**
     * Set backlink storage from URL parameter
     *
     * @return {Promise<void>}
     */
    setBacklinkStorage = () => asyncSessionStorage.setItem('sportnect.remoteLoginBacklink', getUrlParameter('backlink'))

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        const { authedUser } = this.props

        if (!authedUser?.user) {
            this.setBacklinkStorage()
            return <Redirect to="/login" />
        }

        return (
            <div>
                {authedUser?.user?.name}
            </div>
        )
    }
}

export default withRouterConnectWrapper(state => ({
    authedUser: state.auth,
}))(RemoteLogin)
